import response from "@/module/patient/card/questionnaire/analysis/response"

export default {
	getUser({ dispatch, commit, rootState }) {
		if (rootState.auth.id == null)
			throw { code: 'InvalidId', status: 401 }

		return dispatch('provider/loadAllProviders', null, {
			root: true
		})
		.then((providerResponse) => {
			// Setting user for the provider
			if(providerResponse.user)
				commit('setUser', providerResponse.user)
			// Setting all provider in provider module
			if(providerResponse.provider && Array.isArray(providerResponse.provider)) {
				const currProvider = providerResponse.provider.find((provider) => provider.provider === localStorage.getItem('provider'))
				if(currProvider) {
					commit('provider/setProviderId', currProvider.provider, { root: true })
					commit('provider/setProvider', currProvider, { root: true})
				}
				dispatch('provider/getProviderOverview', providerResponse.provider[0].provider, { root: true })
				providerResponse.provider.forEach((provider) => {
					if(providerResponse.profiles)
						provider.profile = providerResponse.profiles
							.map((profile) => ({
								...profile,
								event: profile.events ? profile.events.map((event) => event.id) : []
							}))
							.filter((profile) => profile.provider.includes(provider.provider))
					commit('provider/addProvider', provider, { root: true })
					dispatch('provider/getProvider', provider.provider, { root: true })
				})
				dispatch('provider/getAllImportErrors', {
					provider: providerResponse.provider.map(p => p.provider).join(",")
				}, { root: true })
				
				dispatch('provider/loadAllProviderPatients', null, { root: true })
				dispatch('provider/loadPatientTickets', null, { root: true})
			}
			// Setting events in content
			if(providerResponse.profiles)
				providerResponse.profiles.forEach((profile) => {
					const eventObj = profile.events.reduce((eventAcc, event) =>{
						eventAcc[event.id] = event
						return eventAcc
					}, {})

					commit('content/cache', { event: eventObj }, { root: true })
				})
				commit('provider/finishLoadingAllProviderEvents', null, { root: true })
		})
		.catch((error) => {
			console.log(error)
			throw error
		})
	},

	getContent({ state, rootState }) {
		return this.dispatch('get', {
			url: '/user/' + rootState.auth.id + '/content',
			query: {
				expand: true
			}
		}, {
			root: true
		})
		.then((data) => {

			console.log(data)
		})
		.catch((error) => {
			console.log(error)
		})
	},
	updateUser({ dispatch, commit, rootState }, query) {
		return dispatch('patch', {
			url: '/user/' + rootState.auth.id,
			data: query
		}, {
			root: true
		})
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log(error)
			throw error
		})
	},
	sendSupport({ dispatch, commit, rootState }, question) {
		return dispatch('post', {
			url: '/user/' + rootState.auth.id + '/support',
			data: question
		}, {
			root: true
		})
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log(error)
			throw error
		})
	},
	upload({ state, rootState }, { file }) {

	},
	createMeeting({ dispatch, rootState }, patientId) {
		return dispatch('post', {
			url: '/provider/' + rootState.provider.id + '/patient/' + patientId + '/meeting'
		}, {
			root: true
		})
		.then((response) =>  response)
		.catch((error) => {
			console.error(error)
			throw error
		})
	}
}
